const Carousel = ({ color, type }) => {
  const solid = (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.3334 16H42.6667C36.7841 16 32.0001 20.784 32.0001 26.6667V101.333C32.0001 107.216 36.7841 112 42.6667 112H85.3334C91.2161 112 96.0001 107.216 96.0001 101.333V26.6667C96.0001 20.784 91.2161 16 85.3334 16ZM10.6667 37.3333V90.6667C10.6667 96.5493 15.4507 101.333 21.3334 101.333V26.6667C15.4507 26.6667 10.6667 31.4507 10.6667 37.3333ZM106.667 26.6667V101.333C112.549 101.333 117.333 96.5493 117.333 90.6667V37.3333C117.333 31.4507 112.549 26.6667 106.667 26.6667Z"
        fill={color}
      />
    </svg>
  );
  const regular = (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3334 101.333H32.0001C32.0001 107.216 36.7841 112 42.6667 112H85.3334C91.2161 112 96.0001 107.216 96.0001 101.333H106.667C112.549 101.333 117.333 96.5493 117.333 90.6667V37.3333C117.333 31.4507 112.549 26.6667 106.667 26.6667H96.0001C96.0001 20.784 91.2161 16 85.3334 16H42.6667C36.7841 16 32.0001 20.784 32.0001 26.6667H21.3334C15.4507 26.6667 10.6667 31.4507 10.6667 37.3333V90.6667C10.6667 96.5493 15.4507 101.333 21.3334 101.333ZM106.667 37.3333V90.6667H96.0001V37.3333H106.667ZM42.6667 26.6667H85.3334L85.3387 101.333H42.6667V26.6667ZM21.3334 37.3333H32.0001V90.6667H21.3334V37.3333Z"
        fill={color}
      />
    </svg>
  );
  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Carousel;
